module.exports = __webpack_public_path__ + "img/tj.tj4c009c9.svg";